var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnGrowHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    fill: "none",
    viewBox: "0 0 19.036 19.035",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter887",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    result: "color2",
    values: "-1 0 0 0 1 0 -1 0 0 1 0 0 -1 0 1 -0.21 -0.72 -0.07 1.85981 0 "
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m8.8931 13.636h-0.12868c-0.92522-1.9444-3.2448-3.0264-5.2761-3.3952-0.57876-0.10514-1.897-0.48853-2.2208 0.20744-0.55778 1.1991 0.49017 3.6933 1.0828 4.732 2.4118 4.2273 9.0237 5.0967 12.72 2.017 1.5024-1.2518 2.3567-3.0736 2.6916-4.9768 0.0942-0.53559 0.3607-1.5193-0.08468-1.9635-0.43573-0.43456-1.5591-0.11299-2.0922-0.01621-2.055 0.37306-4.3096 1.455-5.2761 3.3952-1.4255-4.8227 6.0645-6.0387 5.5096-10.552-0.24218-1.9699-2.2818-3.4574-4.2228-2.9723-0.66866 0.16711-1.4235 0.9806-2.059 0.97983-0.5855-7.19e-4 -1.2178-0.75619-1.8016-0.93892-1.8227-0.57054-3.7146 0.50815-4.308 2.2879-1.1841 3.5515 3.6782 5.7305 5.2598 8.2358 0.46744 0.74045 0.20633 2.1111 0.20633 2.9597m-2.8311-12.3c0.7863-0.1959 1.5711-9.37e-4 2.1876 0.50322 0.35324 0.28884 0.78324 0.92472 1.2868 0.92472 0.54547 0 1.0139-0.72789 1.4155-1.024 0.85376-0.62945 2.1389-0.63554 2.9359 0.10068 2.2176 2.0485-1.2408 4.6428-2.5448 6.0044-0.43319 0.45233-1.045 1.4684-1.6825 1.6289-0.61885 0.15585-1.5417-1.2417-1.9262-1.629-1.0028-1.01-2.6365-2.2128-3.1067-3.6031-0.38927-1.1509 0.1966-2.5975 1.4343-2.9058m2.8311 16.418c-3.542-0.15442-6.282-2.8976-6.4342-6.4342 3.7052 0.47073 5.9623 2.7198 6.4342 6.4342m7.7211-6.4342c-0.15262 3.5464-2.8843 6.2794-6.4342 6.4342 0.46912-3.6926 2.7497-5.9662 6.4342-6.4342z",
    fill: "#0e0e0e",
    filter: "url(#filter887)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnGrowHeart);
export default __webpack_public_path__ + "static/media/icn-grow-heart.f995489d4c9feb6a6bef79e43cc42ec3.svg";
export { ForwardRef as ReactComponent };